export default "__VITE_PUBLIC_ASSET__58cee687__"